import lqLogo from './lq-icon.svg';
import lqLogoNoBG from './lq-icon-no-bg.svg';
import dropDownArrow from './drop-down-arrow.svg';

export const LocalImages = {
  LongeviQuestLogo: lqLogo,
  LongeviQuestLogoNoBG: lqLogoNoBG,
  DropDownArrow: dropDownArrow,
};
